const initialState = {
  docCounts: {}
};

const DocumentCountReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'docCounts':
      return {
        ...state,
        docCounts: action.payload
      };
    default:
      return state;
  }
};
export default DocumentCountReducer;
